import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import * as func from "../../common/manipurCommon/FunctionCalls";
import * as api from "../../common/manipurCommon/API";
import { usePermissions } from "../../common/PermissionContext";
import { useLocation, Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Select from "react-select";
import Swal from "sweetalert2";
import Utils from "../../common/manipurCommon/Utils";

const TalentScouting = () => {

    const [talentScoutingCriteriaList, setTalentScoutingCriteriaList] = useState<any[]>([]);
    const [testList, setTestList] = useState<any[]>([]);
    const [searchInput, setSearchInput] = useState("");
    const [talentScoutTestId, setTalentScoutTestId] = useState("");
    const [selectionCriteriaName, setSelectionCriteriaName] = useState("");
    const [selectionCriteriaDescription, setSelectionCriteriaDescription] = useState("");
    const [talentScoutingCriteriaId, setTalentScoutingCriteriaId] = useState("");
    const [talentScoutingCriteriaStatus, setTalentScoutingCriteriaStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        fetchTalentScoutingCriteria();
    }, [])

    async function fetchTalentScoutingCriteria() {
        setIsLoading(true);
        const talntSctngResponse = await func.listTalentScoutingSelectionCriteria();
        setTalentScoutingCriteriaList(Array.isArray(talntSctngResponse) ? talntSctngResponse : [])
        setIsLoading(false);
    }

    const filteredData = talentScoutingCriteriaList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const testNameRender = (rowData) => {
        return <span>{rowData.talentScoutingTestName}</span>;
    };

    const criteriaNameRender = (rowData) => {
        return <span>{rowData.talentScoutingSelectionCriteriaName}</span>;
    };

    const criteriaDescriptionRender = (rowData) => {
        return <span>{rowData.talentScoutingSelectionCriteriaDescription}</span>;
    };

    const testcriteriaStatusRender = (rowData) => {
        return <span>{(rowData.talentScoutingSelectionCriteriaStatus == 1) ? "Active" : "Inactive"}</span>;

    };

    const editDetails = (rowData: any) => {
        return (
            <Link to="#" onClick={() => editTalentScoutingCriteria(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData: { talentScoutingSelectionCriteriaId: any; }) => {
        const tlntId = rowData.talentScoutingSelectionCriteriaId;

        return (
            <Link to="#" onClick={() => DeleteTalentScoutingCriteria(tlntId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function newTalentScoutingCriteria() {
        setIsEdit(false)
        setOpenModal(true)
        const tstResponse = await func.listTalentScouting();
        setTestList(Array.isArray(tstResponse) ? tstResponse : [])
    }

    async function editTalentScoutingCriteria(rowData: { talentScoutingSelectionCriteriaId: any; }) {
        const tlntId = rowData.talentScoutingSelectionCriteriaId;
        setIsEdit(true)
        setOpenModal(true)
        const tstResponse = await func.listTalentScouting();
        setTestList(Array.isArray(tstResponse) ? tstResponse : [])
        const getDetails = await func.getTalentScoutingSelectionCriteria(tlntId);
        setTalentScoutingCriteriaId(getDetails.talentScoutingSelectionCriteriaId);
        setTalentScoutTestId(getDetails.talentScoutingId);
        setSelectionCriteriaName(getDetails.talentScoutingSelectionCriteriaName);
        setSelectionCriteriaDescription(getDetails.talentScoutingSelectionCriteriaDescription);
        setTalentScoutingCriteriaStatus(getDetails.talentScoutingSelectionCriteriaStatus);
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateTalentScoutingCriteria();
            } else {
                if (talentScoutTestId && selectionCriteriaName && selectionCriteriaDescription) {
                    const formData = new FormData();
                    formData.append("talentScoutingId", talentScoutTestId)
                    formData.append("selectionCriteriaName", selectionCriteriaName);
                    formData.append("selectionCriteriaDescription", selectionCriteriaDescription)

                    const createTlntSct = api.CreateTalentScoutingSelectionCriteria;
                    fetch(createTlntSct, {
                        method: "POST",
                        headers: {
                            "Authorization": 'Bearer ' + Utils.getAccessToken()
                        },
                        body: formData
                    })
                        .then((response) => response.json())
                        .then((result) => {
                            if (result.error == false) {
                                Swal.fire({
                                    title: 'Success',
                                    text: result.message,
                                    icon: 'success',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        setOpenModal(false);
                                        fetchTalentScoutingCriteria();
                                    }
                                });
                            } else {
                                if (result.code == 401) {
                                    Utils.logoutUser();
                                }
                                Swal.fire({
                                    title: 'Error',
                                    text: result.message,
                                    icon: 'error',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                })
                            }
                        })
                }
            }
        }
    }

    function updateTalentScoutingCriteria() {
        const formData = new FormData();
        formData.append("talentScoutingId", talentScoutTestId);
        formData.append("selectionCriteriaName", selectionCriteriaName);
        formData.append("selectionCriteriaDescription", selectionCriteriaDescription);
        formData.append("status", talentScoutingCriteriaStatus);

        const updateTlntSct = api.UpdateTalentScoutingSelectionCriteria + '/' + talentScoutingCriteriaId;
        fetch(updateTlntSct, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            setOpenModal(false);
                            fetchTalentScoutingCriteria();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function DeleteTalentScoutingCriteria(tlntId: string) {
        const deleteTlntSctng = api.DeleteTalentScoutingSelectionCriteria + '/' + tlntId + '/0';
        fetch(deleteTlntSctng, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            setOpenModal(false);
                            fetchTalentScoutingCriteria();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })

    }

    return (
        <>
            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Talent Scouting Criteria</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newTalentScoutingCriteria() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px" }}
                                            title="Create Talent Scouting Criteria">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                            </div>
                            <div className="row col-lg-12 mb-10">
                                <div className="col-lg-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="talentScoutingTestName"
                                                header="Talent Scouting Test"
                                                body={testNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="talentScoutingSelectionCriteriaName"
                                                header="Talent Scouting Criteria"
                                                body={criteriaNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="talentScoutingSelectionCriteriaDescription"
                                                header="Criteria Description"
                                                body={criteriaDescriptionRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="talentScoutingSelectionCriteriaStatus"
                                                header="Status"
                                                body={testcriteriaStatusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                openModal && (
                    <Modal
                        show={openModal}
                        size="md"
                        centered>
                        <ModalHeader>
                            <ModalTitle>
                                <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Talent Scouting Selection Criteria</h4>
                            </ModalTitle>
                            <Button
                                variant=""
                                className="btn-close"
                                onClick={() => setOpenModal(false)}
                            ></Button>
                        </ModalHeader>
                        <ModalBody>
                            <form ref={formRef}>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Talent Scouting Test Name</label>
                                        <Select
                                            value={testList.find(tst => tst.talentScoutingId === talentScoutTestId) ? {
                                                value: talentScoutTestId,
                                                label: testList.find(tst => tst.talentScoutingId === talentScoutTestId).talentScoutingTestName
                                            } : null}
                                            onChange={async (e) => {
                                                setTalentScoutTestId(e.value);
                                            }}
                                            required
                                            placeholder="Select Talent Scouting Test"
                                            options={testList.map(tst => ({
                                                value: tst.talentScoutingId,
                                                label: tst.talentScoutingTestName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Criteria Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="selectionCriteriaName"
                                            value={selectionCriteriaName}
                                            onChange={(e) => setSelectionCriteriaName(e.target.value)}
                                            placeholder="Talent Scouting Criteria Name" />
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Criteria Description</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="selectionCriteriaDescription"
                                            value={selectionCriteriaDescription}
                                            onChange={(e) => setSelectionCriteriaDescription(e.target.value)}
                                            placeholder="Talent Scouting Criteria Description" />
                                    </div>
                                </div>
                                {isEdit ?
                                    <>
                                        <div className="row">
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <label className="form-label">Status</label>
                                            </div>
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                    <input
                                                        className="form-check-input text-end"
                                                        type="checkbox"
                                                        checked={talentScoutingCriteriaStatus === '1'}
                                                        id="sportStatus"
                                                        onChange={(e) => {
                                                            setTalentScoutingCriteriaStatus(e.target.checked ? '1' : '0')
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </> : null
                                }
                                <ModalFooter>
                                    <Button
                                        className="btn-primary text-uppercase"
                                        variant="success"
                                        type="submit"
                                        onClick={handleSubmit}
                                    >
                                        <b><i className="fas fa-save" />Save</b>
                                    </Button>
                                </ModalFooter>
                            </form>
                        </ModalBody>
                    </Modal>
                )
            }
        </>
    );
};

export default TalentScouting;